var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _c('form-component', {
    attrs: {
      "formData": _vm.formData
    },
    scopedSlots: _vm._u([{
      key: "form-section",
      fn: function () {
        return [_c('v-card', [_c('v-card-title', [_vm._v(" Forms "), _c('v-spacer'), _c('v-btn', {
          staticClass: "mb-2",
          attrs: {
            "color": "primary",
            "dark": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.onClickShowFormSelection();
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-plus")]), _vm._v(" Add Form ")], 1)], 1), _c('v-card-text', [_c('ul', {
          staticStyle: {
            "list-style-type": "none",
            "margin": "0px",
            "padding": "0px"
          }
        }, [_c('draggable', {
          attrs: {
            "handle": ".handle",
            "list": _vm.formSelectedTableMetadata.items
          }
        }, _vm._l(_vm.formSelectedTableMetadata.items, function (item, index) {
          return _c('li', {
            key: ("pn" + index)
          }, [_c('v-btn', {
            staticClass: "handle",
            attrs: {
              "text": ""
            }
          }, [_c('v-icon', [_vm._v("mdi-menu")])], 1), _c('span', {
            staticClass: "text"
          }, [_vm._v(_vm._s(item.name))]), _c('v-btn', {
            staticClass: "close",
            attrs: {
              "text": ""
            }
          }, [_c('v-icon', {
            staticClass: "mr-2",
            attrs: {
              "color": "primary"
            },
            on: {
              "click": function ($event) {
                return _vm.onClickDeleteSelectedForm(item);
              }
            }
          }, [_vm._v(" mdi-delete ")])], 1), _c('v-btn', {
            staticClass: "close",
            attrs: {
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.onClickViewFormPreview(item);
              }
            }
          }, [_c('v-icon', {
            staticClass: "mr-2",
            attrs: {
              "color": "blue"
            }
          }, [_vm._v(" mdi-eye ")])], 1)], 1);
        }), 0)], 1)])], 1)];
      },
      proxy: true
    }, {
      key: "project-code-alias-section",
      fn: function () {
        return [_vm._l(_vm.addedAliasList, function (al, index) {
          return _c('v-card', {
            key: al.id,
            staticClass: "mb-4 pa-4",
            attrs: {
              "elevation": "2",
              "rounded": "lg"
            }
          }, [_c('div', {
            staticClass: "d-flex justify-space-between align-center mb-3"
          }, [_c('div', {
            staticClass: "text-subtitle-1 font-weight-medium"
          }, [_vm._v(" Alias (" + _vm._s(index + 1) + ") ")]), _c('v-btn', {
            attrs: {
              "icon": "",
              "size": "small",
              "variant": "text",
              "color": "grey-darken-1"
            },
            on: {
              "click": function ($event) {
                return _vm.removeAlias(index, al.alias);
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "size": "20"
            }
          }, [_vm._v("mdi-close")])], 1)], 1), _c('v-text-field', {
            staticClass: "mb-3",
            attrs: {
              "label": "Project Code Alias",
              "placeholder": "Enter alias for project code",
              "rules": [function (v) {
                return !!v || 'Required';
              }],
              "counter": "100",
              "maxlength": "100",
              "outlined": "",
              "dense": "",
              "clearable": ""
            },
            model: {
              value: al.alias,
              callback: function ($$v) {
                _vm.$set(al, "alias", $$v);
              },
              expression: "al.alias"
            }
          })], 1);
        }), _c('v-btn', {
          staticClass: "mb-4",
          attrs: {
            "name": "addButton",
            "color": "primary",
            "prepend-icon": "mdi-plus"
          },
          on: {
            "click": function ($event) {
              return _vm.addProjectCode();
            }
          }
        }, [_vm._v(" Add Project Code Alias ")])];
      },
      proxy: true
    }, {
      key: "default-ethics-section",
      fn: function () {
        return [_c('div', {
          staticClass: "default-ethics"
        }, [_c('v-card', {
          staticClass: "mb-4 pa-4",
          attrs: {
            "elevation": "2",
            "rounded": "lg"
          }
        }, [_c('div', {
          staticClass: "d-flex justify-space-between align-center mb-3"
        }, [_c('div', {
          staticClass: "text-subtitle-1 font-weight-medium"
        }, [_vm._v(" Ethics (If applicable) ")])]), _c('v-text-field', {
          staticClass: "mb-3",
          attrs: {
            "label": "Ethics Number",
            "placeholder": "Enter ethics approval number",
            "counter": "100",
            "maxlength": "100",
            "outlined": "",
            "dense": "",
            "clearable": ""
          },
          model: {
            value: _vm.ethics.value,
            callback: function ($$v) {
              _vm.$set(_vm.ethics, "value", $$v);
            },
            expression: "ethics.value"
          }
        }), _c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6"
          }
        }, [_c('date-picker', {
          class: {
            'date-error': !_vm.ethics.dateEthicsApproved && _vm.showEthicsErrors && _vm.ethics.value
          },
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "Ethics Approved Date",
            "range": false,
            "disabled": _vm.ethics.value ? false : true
          },
          model: {
            value: _vm.ethics.dateEthicsApproved,
            callback: function ($$v) {
              _vm.$set(_vm.ethics, "dateEthicsApproved", $$v);
            },
            expression: "ethics.dateEthicsApproved"
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6"
          }
        }, [_c('date-picker', {
          class: {
            'date-error': !_vm.ethics.dateExpiration && _vm.showEthicsErrors
          },
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "Ethics Expiration Date",
            "range": false,
            "disabled": _vm.ethics.value ? false : true
          },
          model: {
            value: _vm.ethics.dateExpiration,
            callback: function ($$v) {
              _vm.$set(_vm.ethics, "dateExpiration", $$v);
            },
            expression: "ethics.dateExpiration"
          }
        })], 1)], 1)], 1)], 1)];
      },
      proxy: true
    }, {
      key: "multiple-ethics-section",
      fn: function () {
        return [_c('div', {
          staticClass: "add-ethics"
        }, [_vm._l(_vm.addedEthicsList, function (ethics, index) {
          return _c('v-card', {
            key: ethics.id,
            staticClass: "mb-4 pa-4",
            attrs: {
              "elevation": "2",
              "rounded": "lg"
            }
          }, [_c('div', {
            staticClass: "d-flex justify-space-between align-center mb-3"
          }, [_c('div', {
            staticClass: "text-subtitle-1 font-weight-medium"
          }, [_vm._v(" Ethics (" + _vm._s(index + 2) + ") ")]), _c('v-btn', {
            attrs: {
              "icon": "",
              "size": "small",
              "variant": "text",
              "color": "grey-darken-1"
            },
            on: {
              "click": function ($event) {
                return _vm.removeEthics(index, ethics.ethicsNumber);
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "size": "20"
            }
          }, [_vm._v("mdi-close")])], 1)], 1), _c('v-text-field', {
            staticClass: "mb-3",
            attrs: {
              "label": "Ethics Number",
              "placeholder": "Enter ethics approval number",
              "rules": [function (v) {
                return !!v || 'Required';
              }],
              "counter": "100",
              "maxlength": "100",
              "outlined": "",
              "dense": "",
              "clearable": ""
            },
            model: {
              value: ethics.ethicsNumber,
              callback: function ($$v) {
                _vm.$set(ethics, "ethicsNumber", $$v);
              },
              expression: "ethics.ethicsNumber"
            }
          }), _c('v-row', [_c('v-col', {
            attrs: {
              "cols": "12",
              "md": "6"
            }
          }, [_c('date-picker', {
            class: {
              'date-error': !ethics.ethicsDateApproved && _vm.showAddedEthicsErrors
            },
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "placeholder": "Approved Date",
              "range": false
            },
            model: {
              value: ethics.ethicsDateApproved,
              callback: function ($$v) {
                _vm.$set(ethics, "ethicsDateApproved", $$v);
              },
              expression: "ethics.ethicsDateApproved"
            }
          })], 1), _c('v-col', {
            attrs: {
              "cols": "12",
              "md": "6"
            }
          }, [_c('date-picker', {
            class: {
              'date-error': !ethics.ethicsDateExpiration && _vm.showAddedEthicsErrors
            },
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "placeholder": "Expiration Date",
              "range": false
            },
            model: {
              value: ethics.ethicsDateExpiration,
              callback: function ($$v) {
                _vm.$set(ethics, "ethicsDateExpiration", $$v);
              },
              expression: "ethics.ethicsDateExpiration"
            }
          })], 1)], 1)], 1);
        }), _c('v-btn', {
          staticClass: "mb-4",
          attrs: {
            "name": "addButtonEthics",
            "color": "primary",
            "prepend-icon": "mdi-plus"
          },
          on: {
            "click": function ($event) {
              return _vm.addEthicsNumber();
            }
          }
        }, [_vm._v(" Add Ethics ")])], 2)];
      },
      proxy: true
    }])
  }), _c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "right": "",
      "temporary": "",
      "width": "650px"
    },
    model: {
      value: _vm.isSelectingForms,
      callback: function ($$v) {
        _vm.isSelectingForms = $$v;
      },
      expression: "isSelectingForms"
    }
  }, [_c('v-list-item', [_c('h3', [_vm._v("Select Form(s) to link")])]), _c('v-divider'), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" Forms "), _c('v-spacer'), _c('v-text-field', {
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: _vm.navigationDrawerFormSelectionMetadata.search,
      callback: function ($$v) {
        _vm.$set(_vm.navigationDrawerFormSelectionMetadata, "search", $$v);
      },
      expression: "navigationDrawerFormSelectionMetadata.search"
    }
  })], 1), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.navigationDrawerFormSelectionMetadata.headers,
      "items": _vm.navigationDrawerFormSelectionMetadata.items,
      "items-per-page": 5,
      "search": _vm.navigationDrawerFormSelectionMetadata.search,
      "item-key": "_id",
      "show-select": ""
    },
    scopedSlots: _vm._u([{
      key: "item.actions",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "color": "blue"
          },
          on: {
            "click": function ($event) {
              return _vm.onClickViewFormPreview(item);
            }
          }
        }, [_vm._v(" mdi-eye ")])];
      }
    }], null, true),
    model: {
      value: _vm.navigationDrawerFormSelectionMetadata.selected,
      callback: function ($$v) {
        _vm.$set(_vm.navigationDrawerFormSelectionMetadata, "selected", $$v);
      },
      expression: "navigationDrawerFormSelectionMetadata.selected"
    }
  })], 1), _c('v-btn', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.onClickAddSelectedForms
    }
  }, [_vm._v(" Add ")]), _c('v-dialog', {
    model: {
      value: _vm.isPreviewFormShown,
      callback: function ($$v) {
        _vm.isPreviewFormShown = $$v;
      },
      expression: "isPreviewFormShown"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" Preview ")]), _c('v-card-text', [_vm.questionsMetadata.questionRawList && _vm.isPreviewFormShown ? [_c('form-display', {
    attrs: {
      "questionList": _vm.questionsMetadata.questionRawList,
      "formMetadata": _vm.formMetadata
    }
  })] : _vm._e()], 2)], 1)], 1)], 1)], 1), _vm.formData.model ? _c('section', [_c('v-col', [_c('div', {
    staticClass: "float-right"
  }, [_c('b', [_vm._v("Created By:")]), _vm._v(" " + _vm._s(_vm.createdBy.fullName) + " "), _c('br'), _c('b', [_vm._v("Created At:")]), _vm._v(" " + _vm._s(_vm.createdAt) + " ")])])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }